__turbopack_context__.v({
  "priceNoticeDesktopPositioning": "PriceTaxExclusiveNotice-module-scss-module__4SqayW__priceNoticeDesktopPositioning",
});
